import { ConfigProvider } from 'antd';
import ptBR from 'antd/locale/pt_BR';
import { AppRoutes } from '@/routes';

import { ShowAlert } from '@/components/ShowAlert';

import { AuthProvider } from '@/contexts/auth.context';
import { AlertProvider } from '@/contexts/alert.context';
import { NotificationProvider } from '@/contexts/notification.context';
import { ServiceStatusProvider, useServiceStatus } from '@/contexts/service-status.context';
import { ErrorBoundary, SystemOffline, ServiceStatusToast } from '@/shared/components';
import { useSessionExpired } from '@/shared/hooks/useSessionExpired';

function AppContent() {
  const { isSystemOffline } = useServiceStatus();

  useSessionExpired();

  if (isSystemOffline) {
    return <SystemOffline />;
  }

  return (
    <>
      <ServiceStatusToast />
      <AppRoutes />
      <ShowAlert />
    </>
  );
}

function App() {
  return (
    <ConfigProvider locale={ptBR}>
      <ErrorBoundary>
        <AlertProvider>
          <ServiceStatusProvider>
            <AuthProvider>
              <NotificationProvider>
                <AppContent />
              </NotificationProvider>
            </AuthProvider>
          </ServiceStatusProvider>
        </AlertProvider>
      </ErrorBoundary>
    </ConfigProvider>
  );
}

export default App;
